import { ListFundBasketsParams } from "../../api/funds";

export const fundBasketKeys = {
  all: ["fund-basket"] as const,
  lists: () => [...fundBasketKeys.all, "list"] as const,
  list: (variables?: ListFundBasketsParams) =>
    [...fundBasketKeys.lists(), variables ?? {}] as const,
  details: () => [...fundBasketKeys.all, "detail"] as const,
  detail: (id: number) => [...fundBasketKeys.details(), { id }] as const,
  analytics: {
    all: () => [...fundBasketKeys.all, "analytics"] as const,
    detail: (id: number, benchmark?: string) =>
      [...fundBasketKeys.analytics.all(), { id, benchmark }] as const,
  },
  clients: (id?: number) => [...fundBasketKeys.all, "clients", { id }],
  chart: {
    all: () => [...fundBasketKeys.all, "chart"] as const,
    detail: (id: number, period?: string, benchmark?: string) =>
      [...fundBasketKeys.chart.all(), id, period, benchmark] as const,
    backtest: (
      id: number,
      params?: {
        period?: string;
        benchmark?: string;
        initialAmount?: number;
        sipAmount?: number;
      }
    ) => [...fundBasketKeys.chart.all(), id, "backtest", params] as const,
  },
};
